import { useState } from "react";
import { Link } from "react-router-dom";
import { Pencil, Trash2, Copy, ChevronDown, Split, Layers, AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { MOMENTO_LABEL, OBIEZIONE_LABEL } from "../lib/constants";

const copy = (t) => { navigator.clipboard?.writeText(t); toast.success("Frase copiata"); };

export const ClusterCard = ({ cluster: c, onEdit, onDelete, onSplit, daConfermare }) => {
  const [open, setOpen] = useState(false);
  const varianti = c.varianti || [];
  return (
    <div data-testid={`cluster-card-${c.id}`} className="surface surface-hover group flex min-w-0 flex-col gap-3 p-4">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-xs font-mono uppercase tracking-wide text-muted-foreground">{c.titolo}</p>
          <p data-testid="cluster-rep" className="mt-1 text-sm font-medium leading-relaxed">{c.frase_rappresentativa}</p>
        </div>
        <div className="flex shrink-0 gap-1 transition-opacity sm:opacity-60 sm:group-hover:opacity-100">
          <button data-testid={`cluster-copy-${c.id}`} onClick={() => copy(c.frase_rappresentativa)} className="rounded-md p-1.5 hover:bg-secondary hover:text-white" title="Copia"><Copy className="h-3.5 w-3.5" /></button>
          {onEdit && <button data-testid={`cluster-edit-${c.id}`} onClick={() => onEdit(c)} className="rounded-md p-1.5 hover:bg-secondary hover:text-white" title="Modifica"><Pencil className="h-3.5 w-3.5" /></button>}
          {onSplit && varianti.length > 0 && <button data-testid={`cluster-split-${c.id}`} onClick={() => onSplit(c)} className="rounded-md p-1.5 hover:bg-secondary hover:text-amber-300" title="Separa le varianti"><Split className="h-3.5 w-3.5" /></button>}
          {onDelete && <button data-testid={`cluster-delete-${c.id}`} onClick={() => onDelete(c)} className="rounded-md p-1.5 hover:bg-secondary hover:text-red-400" title="Elimina"><Trash2 className="h-3.5 w-3.5" /></button>}
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-1.5 text-[11px]">
        {c.momento && c.momento !== "trasversale" && <span className="rounded-full border border-border px-2 py-0.5 text-muted-foreground">{MOMENTO_LABEL[c.momento] || c.momento}</span>}
        {c.obiezione_tag && <span className="rounded-full border border-red-500/30 bg-red-500/10 px-2 py-0.5 text-red-300">{OBIEZIONE_LABEL[c.obiezione_tag] || c.obiezione_tag}</span>}
        {daConfermare && <span data-testid="badge-da-confermare" className="rounded-full border border-amber-500/40 bg-amber-500/10 px-2 py-0.5 text-amber-300">intento da confermare</span>}
        {c.incerto && <span data-testid="badge-incerto" className="inline-flex items-center gap-1 rounded-full border border-amber-500/40 bg-amber-500/10 px-2 py-0.5 text-amber-300"><AlertTriangle className="h-3 w-3" /> da revisionare</span>}
        {c.troppo_varianti && <span className="rounded-full border border-amber-500/40 bg-amber-500/10 px-2 py-0.5 text-amber-300">troppe varianti</span>}
      </div>

      {varianti.length > 0 && (
        <div>
          <button data-testid={`cluster-variants-toggle-${c.id}`} onClick={() => setOpen(!open)} className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-white">
            <Layers className="h-3.5 w-3.5" /> {varianti.length} varianti <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
          </button>
          {open && (
            <ul data-testid={`cluster-variants-${c.id}`} className="mt-2 space-y-1.5 border-l-2 border-border pl-3">
              {varianti.map((v, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-gray-300">
                  <span className="mt-1 h-1 w-1 shrink-0 rounded-full bg-muted-foreground" /> {typeof v === "string" ? v : v.testo}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}

      {c.fonti?.length > 0 && (
        <div className="flex flex-wrap gap-2 border-t border-border pt-2 text-[11px] text-muted-foreground">
          {c.fonti.slice(0, 4).map((f, i) => (
            <Link key={i} to={`/contenuti/${f.content_id}`} className="truncate hover:text-white hover:underline" title={f.titolo}>fonte: {(f.titolo || "").slice(0, 24) || f.content_id.slice(0, 8)}</Link>
          ))}
          {c.fonti.length > 4 && <span>+{c.fonti.length - 4}</span>}
        </div>
      )}
    </div>
  );
};
